<script setup lang="ts">
import { usePreferredDark } from '@vueuse/core'

const props = defineProps<{
  type: 'NotLoggedIn' | 'LoggedIn'
}>()

const isDark = usePreferredDark()

const BACKGROUNDS = {
  LoggedIn: {
    light: 'https://padlet.net/dashboard/no_access_pages/owl_sofa_light.svg',
    dark: 'https://padlet.net/dashboard/no_access_pages/owl_sofa_dark.svg',
  },
  NotLoggedIn: {
    light: 'https://padlet.net/dashboard/no_access_pages/owl_luggage_light.svg',
    dark: 'https://padlet.net/dashboard/no_access_pages/owl_luggage_dark.svg',
  },
}
</script>

<template>
  <div class="absolute inset-0 pointer-events-none" id="access-request-background-illustration">
    <div class="relative w-full h-full">
      <!-- Bottom Illustration - Desktop with crossfade transition -->
      <img
        :src="BACKGROUNDS[props.type].light"
        alt=""
        class="illustration-transition w-full absolute bottom-0 end-0 z-0 tablet-portrait:max-w-[65vw] h-auto"
        :class="{ 'opacity-0': isDark }"
      />
      <img
        :src="BACKGROUNDS[props.type].dark"
        alt=""
        class="illustration-transition w-full absolute bottom-0 end-0 z-0 tablet-portrait:max-w-[65vw] h-auto dark-mode-greyscale"
        :class="{ 'opacity-0': !isDark }"
      />
    </div>
  </div>
</template>

<style scoped>
.illustration-transition {
  transition: opacity 0.4s ease-in-out;
}

.dark-mode-greyscale {
  filter: grayscale(100%);
}
</style>
